import { Reviews } from 'shared/components/Reviews';
import { useToggleState } from '@cian/react-utils';
import { useState } from 'react';
import { REVIEWS } from 'shared/constants/reviews';
import { TReview } from 'shared/types/reviews';

export const ReviewsContainer: React.FC = () => {
  const { state: isOpen, toggle: toggleIsOpen } = useToggleState(false);

  const [activeReview, setActiveReview] = useState<TReview | undefined>(undefined);

  const handleOpenModal = (id: number) => {
    toggleIsOpen();

    setActiveReview(REVIEWS.find(review => review.id === id));
  };

  return (
    <Reviews activeReview={activeReview} isOpen={isOpen} onClickReview={handleOpenModal} onChangeOpen={toggleIsOpen} />
  );
};
